export { default as SearchFormInput } from './SearchFormInput.vue';
